import api from '../../api/client';
import React, { useState, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { Button, Row, Col, Form, Spinner } from "react-bootstrap";
import AccountingReports from "../../components/accounts/accountsReport";
import Card from "../../components/Card/MainCard";

const GeneralLedger = () => {
  return (
    <>
      <AccountingReports reportType="general-ledger" />
    </>
  );
};

export default GeneralLedger;
